import { useEffect, useState } from 'react';
const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5008';

export function useDashboardSummary(path, { empresa = '', refreshSignal = 0, enabled = true } = {}) {
  const [state, setState] = useState({ data: null, loading: enabled, error: '' });
  useEffect(() => {
    if (!enabled) { setState({ data: null, loading: false, error: '' }); return undefined; }
    const controller = new AbortController();
    async function load() {
      setState({ data: null, loading: true, error: '' });
      try {
        const token = localStorage.getItem('@user_token');
        if (!token) throw new Error('Sua sessão expirou. Faça login novamente.');
        const query = empresa ? `?${new URLSearchParams({ empresa })}` : '';
        const response = await fetch(`${baseUrl.replace(/\/$/, '')}${path}${query}`, {
          headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }, signal: controller.signal,
        });
        const messages = { 401: 'Sua sessão expirou. Faça login novamente.', 403: 'Você não tem permissão para consultar este indicador.', 429: 'Muitas consultas. Aguarde e tente novamente.' };
        if (!response.ok) throw new Error(messages[response.status] || 'Não foi possível carregar este indicador.');
        const json = response.status === 204 ? null : await response.json();
        if (!controller.signal.aborted) setState({ data: Array.isArray(json) ? json[0] ?? null : json, loading: false, error: '' });
      } catch (error) {
        if (!controller.signal.aborted) setState({ data: null, loading: false, error: error.message });
      }
    }
    load();
    return () => controller.abort();
  }, [path, empresa, refreshSignal, enabled]);
  return state;
}
